import { render, staticRenderFns } from "./ExpectationList.vue?vue&type=template&id=187a84fc&"
import script from "./ExpectationList.vue?vue&type=script&lang=js&"
export * from "./ExpectationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports